import {paths} from '../config/app-config';

const logout = async(key) => {
  try {
    let logoutPath;
    logoutPath = paths.samlLogoutPath;
    window.location = logoutPath;
    return true;
  } catch(e) {
    return false;
  }
}


export default logout;
